import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FantasyGameDetailsV2, FantasyGameV2 } from 'projects/core/src/lib/modules/loyalty/fantasy/models/fantasy-game.model';
import { FantasyGameService, GameStatus } from '@fgb/core';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'fgb-fantasy-game-panel-v2',
  templateUrl: './fantasy-game-panel-v2.component.html',
  styleUrl: './fantasy-game-panel-v2.component.scss',
})
export class FantasyGamePanelV2Component implements OnChanges {
  @Input() games: FantasyGameV2[] = [];
  @Input() isFutureGame: boolean = false;

  gameEnds: boolean = false;
  gameDate: string;
  gameTime: string;
  gameDetails: FantasyGameDetailsV2;
  gameDisplayed: FantasyGameV2;

  private lastGameId: number | null = null;

  constructor(private fantasyGameService: FantasyGameService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.games || !this.games?.length) {
      return;
    }

    this.gameDisplayed = this.games[0];

    if (this.gameDisplayed.Status == GameStatus.Processed) {
      this.gameDisplayed = this.games.find((game) => game.Status !== GameStatus.Processed) || this.games[0];
    }

    const gameId = this.gameDisplayed.GameId;

    // Fetch details only once per game
    if (this.lastGameId !== gameId) {
      this.lastGameId = gameId;

      this.fantasyGameService.fetchGameDetailsV2(gameId).subscribe((details) => {
        this.gameDetails = details;
      });
    }

    this.games = this.games.map((game) => ({
      ...game,
      GameDateOnly: moment.utc(game.GameDate).local().format('ddd, DD MMM'),
      GameTimeOnly: moment.utc(game.GameDate).local().format('H:mm'),
    }));

    this.gameDate = moment.utc(this.games[0].GameDate).local().format('ddd, DD MMM');
    this.gameTime = moment.utc(this.games[0].GameDate).local().format('H:mm');
  }

  onGameEnds(event: any) {
    this.gameEnds = event;
  }
}
